import { configurator, Modifier, type DragOperation } from "@skilitics/drag-drop";

import type { Coordinates } from "./types.ts";

export class SnapVerticalCenterToCursor extends Modifier {
  public apply(operation: DragOperation): Coordinates {
    const { transform, position, shape } = operation;

    if (this.disabled) return transform;

    const activatorCoordinates = position?.initial;
    const draggingNodeRect = shape?.initial?.boundingRectangle;

    if (!activatorCoordinates || !draggingNodeRect) {
      return transform;
    }

    const offsetY = activatorCoordinates.y - draggingNodeRect.top;

    return {
      ...transform,
      y: transform.y + offsetY - draggingNodeRect.height / 2,
    };
  }

  static configure = configurator(SnapVerticalCenterToCursor);
}
